import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.file;

export const fileSelectors = {
  templates: createSelector(selector, (state) => state.templates),
  results: createSelector(selector, (state) => state.results),
  users: createSelector(selector, (state) => state.users),
};
